module.exports = __webpack_public_path__ + "static/media/game.fb8cda8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/game.svg
// module id = 529
// module chunks = 0